import { ArrowRight } from 'lucide-react'

import { Button } from '@/common/ui'
import { NAVIGATION_COPY } from '@/locales/en'

type Props = {
    onContactSupport: () => void
}

export default function AccountSupportCard({ onContactSupport }: Props) {
    const copy = NAVIGATION_COPY.account.support

    return (
        <div className="self-stretch p-6 bg-stone-50 rounded-2xl flex flex-col md:flex-row justify-start md:items-center items-start gap-4 md:gap-6 overflow-hidden">
            <div className="flex-1 flex justify-start items-start">
                <div className="flex-1 inline-flex flex-col justify-center items-start gap-2">
                    <div className="self-stretch justify-start text-content-primary text-base font-medium leading-6">
                        {copy.title}
                    </div>
                    <div className="self-stretch justify-start text-content-secondary text-base font-normal leading-6">
                        {copy.description}
                    </div>
                </div>
            </div>
            <Button
                variant="tertiary"
                size="lg"
                className="w-full md:w-auto justify-center px-6 py-3 rounded-full self-stretch md:self-auto"
                onClick={onContactSupport}
            >
                {copy.cta}
                <ArrowRight size={16} />
            </Button>
        </div>
    )
}
